export const TwoFactorAuthenticationConstants = {
    TwoFactorAuthenticationMethod: {
        NotYetRegistered: 0,
        SMS: 1,
        Voice: 2,
        AuthApp: 3
    }
};
